"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _PanelHeader = _interopRequireDefault(require("./PanelHeader"));

var _PanelBody = _interopRequireDefault(require("./PanelBody"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Panel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Panel, _Component);

  var _super = _createSuper(Panel);

  function Panel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Panel);
    _this = _super.call(this, props);
    _this.state = {
      isOpen: true
    };
    _this.togglePanel = _this.togglePanel.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Panel, [{
    key: "togglePanel",
    value: function togglePanel() {
      if (!this.props.collapsible) {
        return;
      }

      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          customClass = _this$props.customClass,
          _this$props$collapsib = _this$props.collapsible,
          collapsible = _this$props$collapsib === void 0 ? false : _this$props$collapsib,
          title = _this$props.title,
          titleClass = _this$props.titleClass,
          bodyClass = _this$props.bodyClass,
          _this$props$newStyle = _this$props.newStyle,
          newStyle = _this$props$newStyle === void 0 ? false : _this$props$newStyle;
      var isOpen = this.state.isOpen;
      var hasChildren = Array(children).toString() !== '';
      var baseClass = 'panel';
      if (newStyle) baseClass = "".concat(baseClass, "-new");
      return (0, _preact.h)("div", {
        className: "".concat(customClass || '', " ").concat(!isOpen || !hasChildren ? "".concat(baseClass, "-collapsed") : '')
      }, (0, _preact.h)("div", {
        className: baseClass
      }, title ? (0, _preact.h)(_PanelHeader.default, {
        newStyle: newStyle,
        collapsible: collapsible,
        isOpen: isOpen,
        togglePanel: function togglePanel() {
          return _this2.togglePanel();
        },
        title: title,
        customClass: titleClass
      }) : null, hasChildren ? (0, _preact.h)(_PanelBody.default, {
        collapsible: collapsible,
        isOpen: isOpen,
        customClass: bodyClass
      }, children) : null));
    }
  }]);
  return Panel;
}(_preact.Component);

var _default = Panel;
exports.default = _default;